import React, { useState } from "react";

import { Button, Statistic, Descriptions, Select } from "antd";

import { ContainerOutlined } from "@ant-design/icons";

import DateTimeJob from "../../job/status/datetime"; /*TODO:QUOTE*/

import StatisticAmount from "../../../core/components/widget/amountInline/statistic";

const { Option } = Select;

const Content = ({ children, extra }) => {
    return (
        <div className="content">
            {/*<img src="https://icon-library.com/images/translate-icon-png/translate-icon-png-9.jpg" alt="content" width="100px"/>*/}
            <div className="main">{children}</div>
            <div className="extra">{extra}</div>
        </div>
    );
};

const extraContent = (props) => (
    <div
        style={{
            display: "flex",
            width: "max-content",
            justifyContent: "flex-end",
        }}
    >
        <Statistic title="Status" value={props.quote.status} style={{ marginRight: 32 }} />

        {!props.forVendor && (
            <StatisticAmount
                title="Price"
                prefix={props.quote.totalToReceiveType}
                value={props.quote.totalToReceiveValue}
            />
        )}
    </div>
);

const Details = (props) => {
    const { quote, column } = props;

    return (
        <>
            <Content extra={extraContent(props)}>
                <Descriptions size="small" column={column != null ? column : 2}>
                    <Descriptions.Item label="LP / LR / E-ID"> {quote.externalId} </Descriptions.Item>
                    <Descriptions.Item label="Manager">
                        <Button size="small" type="dashed">
                            {" "}
                            <ContainerOutlined />
                            {quote.manager ? quote.manager.lastName + ", " + quote.manager.firstName : ""}
                        </Button>
                    </Descriptions.Item>

                    <Descriptions.Item label="Project">
                        <Button size="small" type="dashed">
                            {" "}
                            <ContainerOutlined />
                            {quote.project ? quote.project.name : ""}
                        </Button>
                    </Descriptions.Item>
                    <Descriptions.Item label="Point Of Sale">
                        <Button size="small" type="dashed">
                            {" "}
                            <ContainerOutlined />
                            {quote.pointOfSale ? quote.pointOfSale.name : ""}
                            {quote.component ? " (" + quote.component.name + ")" : ""}
                        </Button>
                    </Descriptions.Item>

                    {!props.forVendor && (
                        <Descriptions.Item label="Receivable Code">{quote.receivableCode}</Descriptions.Item>
                    )}
                    {!props.forVendor && (
                        <Descriptions.Item label="Client Deadline At">
                            <DateTimeJob value={quote.clientDeadlineAt} status={quote.status} />
                        </Descriptions.Item>
                    )}
                    <Descriptions.Item label="Notes"> {quote.notes} </Descriptions.Item>
                </Descriptions>
            </Content>
        </>
    );
};

export default Details;
